import React from 'react';
import { MapPin, Phone, Mail, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
const Footer = () => {
  const logoSrc = '/trade-zone-logo.png';
  const quickLinks = [{
    label: 'Home',
    href: '#home'
  }, {
    label: 'Products',
    href: '#products'
  }, {
    label: 'About',
    href: '#about'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  const socialLinks = [{
    icon: Facebook,
    href: '#',
    label: 'Facebook'
  }, {
    icon: Twitter,
    href: '#',
    label: 'Twitter'
  }, {
    icon: Linkedin,
    href: '#',
    label: 'LinkedIn'
  }, {
    icon: Instagram,
    href: '#',
    label: 'Instagram'
  }];
  const scrollToSection = href => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-[#1a1a1a] border-t border-[#2d2d2d]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src={logoSrc}
              alt="Trade Zone Equipments Logo"
              className="h-10 object-contain object-left"
              loading="lazy"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
            <p className="text-gray-400 leading-relaxed">
              Your trusted partner for quality Trade Zone Equipments parts. Excellence in every component.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => {
              const IconComponent = social.icon;
              return <a key={index} href={social.href} aria-label={social.label} className="w-10 h-10 bg-[#2d2d2d] rounded-lg flex items-center justify-center text-gray-400 hover:bg-[#ff6b35] hover:text-white transition-all duration-300 hover:scale-110">
                    <IconComponent size={18} />
                  </a>;
            })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <span className="text-white font-bold text-lg mb-4 block">Quick Links</span>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => <li key={index}>
                  <button onClick={() => scrollToSection(link.href)} className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-300">
                    {link.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <span className="text-white font-bold text-lg mb-4 block">Contact</span>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#ff6b35] mt-1 shrink-0" />
                <span className="text-gray-400 text-sm">
                SECOND FLOOR, 8/1, Princep St, opp. IFA OFFICE, Esplanade, Chowringhee North, Bow Barracks, Kolkata, West Bengal 700001
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#ff6b35] shrink-0" />
                <span className="text-gray-400 text-sm">+91 98756 30348</span>
              </li>
              <li className="flex items-center space-x-3">+91 98756 30348</li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <span className="text-white font-bold text-lg mb-4 block">Business Hours</span>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex justify-between">
                <span>Monday - Friday:</span>
                <span className="text-white">8:00 AM - 6:00 PM</span>
              </li>
              <li className="flex justify-between">
                <span>Saturday:</span>
                <span className="text-white">9:00 AM - 4:00 PM</span>
              </li>
              <li className="flex justify-between">
                <span>Sunday:</span>
                <span className="text-white">Closed</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#2d2d2d] mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2026 Trade Zone Equipments. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <button className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-300">
                Privacy Policy
              </button>
              <button className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-300">
                Terms of Service
              </button>
              <button className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-300">
                Developed by Mango
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;